<template>
    <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl mt-1">
        <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-xl">
            <div v-if="!productLoading">
                <div class="relative flex flex-col">
                    <div class="w-full w-full flex justify-between">
                        <div class="input-wrapper">
                            <span class="mb-0 text-sm font-bold text-grey">Lot Tracking</span>
                            <div class="flex mt-1">
                                <label class="flex items-center cursor-pointer">
                                    <input type="checkbox" :disabled="!isParentLotTrackingEnabled" v-model="lotTracking" class="hidden peer">
                                    <div class="relative toggle-bg  border-2  h-6 w-11 rounded-full" :class="lotTracking?'bg-theme-green border-theme-green':'bg-theme-red border-theme-red'"></div>
                                </label>
                            </div>
                        </div>
                        <div class=" mt-2">
                            <div class="text-xs text-grey">Total Count</div>
                            <div class="text-sm text-center">0</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-row flex-wrap items-center gap-2 mt-3 mb-3 justify-center" > 
                <div class="w-[125px]">
                    <div class="input-wrapper">
                        <button @click="toggle('editVariant', editItem)" :disabled="disabledVariant" :class="(editVariant && editVariant.id==editItem.id)?'bg-theme-green':'bg-theme-grey'" class="flex justify-center items-center py-3 w-full rounded border border-theme-green text-white text-sm font-bold tracking-wider disabled:border-grey disabled:bg-grey">{{editItem.size}}</button>
                    </div>
                </div>  
            </div>
            <div class="bg-theme-borderblack h-1 w-full my-4"></div>
            <div>
                <component :form="updatedForm" :updatedLotInfo="updatedLotInfo" :asn="asn" :mergeProduct="mergeProduct" :fulfillment="fulfillment" :is="type" :categories="categories" :brands="brands" :taxes="taxes" :editItem="editItem" :editVariant="editVariant" :type="type" :lotTracking="lotTracking" :media="media" :aromas="aromas" :terpenes="terpenes" @updateLotTracking="updateLotTracking" @updateField="updateField" @updatedLotForm="updatedLotForm" />
            </div>
        </div>
        
    </div> 
</template>
<script>
import { ref, defineComponent } from 'vue'
import defaultVariant from './regular/defaultVariant.vue'
import editVariant from './regular/editVariant.vue'
import {mapGetters, mapActions, mapMutations} from 'vuex'
import { useSnackbar } from 'vue3-snackbar'
import StringHelper from '@/helpers/string'
import PriceMarkupSettingApis from "@/controllers/LocationMarkupPrice";
import ObjectHelper from '@/helpers/object'
import ProductHelper from '@/helpers/product'

export default defineComponent({
    props: ['productLoading', 'asn', 'mergeProduct', 'fulfillment', 'categories', 'brands', 'taxes', 'editItem', 'media', 'aromas', 'terpenes', 'globalSetting'],
    components: {
        defaultVariant,
        editVariant,
    },
    setup() {
        const snackbar = useSnackbar();
        const type = ref('defaultVariant')
        const isParentLotTrackingEnabled = ref(false)
        const lotTracking = ref(false)
        const editVariant = ref({})
        const productCbdThcType = ref('')
        const disabledVariant = ref(false)
        const updatedForm = ref({
            name: '',
            brandId: '',
            categoryId: '',
            featuredCategoryIds: [],
            strain: '',
            licensedProducer: '',
            tax: [],
            sku: '',
            barcode: '',
            complianceType: '',
            concentration_unit: '',
            description: '',
            longDescription: '',
            variantName: '',

            cost: '',
            price: '',
            sale_price: '',
            onlineSalePrice: '',

            fulfillmentTime: '',
            dryCannabisEquivalency: '',
            thc_cbd_value_type: 'single',
            thc: '',
            thc_min: '',
            thc_max: '',
            cbd: '',
            cbd_min: '',
            cbd_max: '',
            totalTerp: '',
            caseSize: '',

            stock: 0,
            activeStock: 0,
            reservedQty: 0
        })
        const updatedLotInfo = ref(null)
        const markupPrices = ref([])
        const markupPercent = ref('')

        return {snackbar, type, isParentLotTrackingEnabled, editVariant, lotTracking, productCbdThcType, disabledVariant, updatedForm, updatedLotInfo, markupPrices, markupPercent}
    },
    async mounted(){
        this.type = 'defaultVariant'
        this.editVariant = {}
        this.vm_currentTab({})
        this.updateGlobalSetting()

        await this.getMarkupPrices()
        this.load()

        this.emitter.on('toggleVariant', this.toggleVariant);
        this.emitter.on('changeThcCbdType', this.changeThcCbdType);
    },
    unmounted(){
        this.emitter.off('toggleVariant', this.toggleVariant);
        this.emitter.off("changeThcCbdType", this.changeThcCbdType)
    },
    beforeDestroy() {
        this.emitter.off('toggleVariant', this.toggleVariant);
        this.emitter.off("changeThcCbdType", this.changeThcCbdType)
    },
    watch: {
        'editItem.id'(){
            this.type = 'defaultVariant'
            this.lotTracking = false
            this.editVariant = {}
            this.load()
        },
        'mergeProduct.id'(){
            if(this.mergeProduct?.id){
                this.updateMissing()
            }
        },
        'globalSetting.lotTracking'(){
            this.updateGlobalSetting()
        },
        'updatedForm.complianceType'(){
            this.calculatePrice()
        }
    },
    computed: {
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected',
            vg_modified: 'modifiedForm/status'
        })  
    },
    methods: {
        async getMarkupPrices(){
            let res = await PriceMarkupSettingApis.fetchByLocationId(this.vg_selectedLocation.id)
            this.markupPrices = ObjectHelper.getDefaultMarkup(res?.data?.payload)
        },
        load(){
            this.updatedForm.name = this.asn.name
            this.updatedForm.brandId = this.asn.brandModel?.id ? this.asn.brandModel?.id : null
            this.updatedForm.categoryId = ""
            this.updatedForm.featuredCategoryIds = []
            this.updatedForm.strain = this.editItem.strain
            this.updatedForm.tax = []
            this.updatedForm.complianceType = this.asn.complianceType ? StringHelper.parseComplianceType(this.asn.complianceType) : this.editItem.complianceType?StringHelper.parseComplianceType(this.editItem.complianceType):''
            this.updatedForm.sku = this.asn.sku
            this.updatedForm.barcode = this.asn.productGtin
            this.updatedForm.concentration_unit = this.asn.concentrationUnit
            this.updatedForm.description = this.asn?.description ? this.asn?.description : ''
            this.updatedForm.longDescription = this.asn?.longDescription ? this.asn?.longDescription : (this.asn?.masterProduct?.longDescription ? this.asn?.masterProduct?.longDescription:'')
            this.updatedForm.thc_cbd_value_type = 'single'
            this.updatedForm.licensedProducer = this.asn.licensedProducer ? this.asn.licensedProducer : null
            this.updatedForm.variantName= this.asn.variantName
            this.updatedForm.dryCannabisEquivalency = this.asn?.masterProduct?.weight_equivalent_dry_cannabis ? this.asn?.masterProduct?.weight_equivalent_dry_cannabis:''
            
            // pricing
            if(this.markupPrices.length){
                this.updatedForm.cost = this.asn?.cost
                this.calculatePrice()
            }

            // cannabis
            this.updatedForm.fulfillmentTime = this.asn.fulfillmentTime ? this.asn.fulfillmentTime : this.fulfillment
            this.updatedForm.thc = this.asn.thc || this.asn.thc===0 ? this.asn.thc : ''
            this.updatedForm.thc_min = this.asn.thcMin || this.asn.thcMin===0 ? this.asn.thcMin : ''
            this.updatedForm.thc_max = this.asn.thcMax || this.asn.thcMax===0 ? this.asn.thcMax : ''
            this.updatedForm.cbd = this.asn.cbd || this.asn.cbd===0 ? this.asn.cbd : ''
            this.updatedForm.cbd_min = this.asn.cbdMin || this.asn.cbdMin===0 ? this.asn.cbdMin : ''
            this.updatedForm.cbd_max = this.asn.cbdMax || this.asn.cbdMax===0 ? this.asn.cbdMax : ''
            this.updatedForm.totalTerp = this.asn.totalTerp || this.asn.totalTerp===0 ? this.asn.totalTerp : ''
            this.updatedForm.caseSize = this.asn.packSize

        },
        calculatePrice(){
            let price = ProductHelper.calculatePrice(this.markupPrices, this.updatedForm.complianceType, this.asn.cost)
            this.updatedForm.price = price
            this.updatedForm.sale_price = price
            this.updatedForm.onlineSalePrice = price
        },
        updateGlobalSetting(){
            this.isParentLotTrackingEnabled = this.globalSetting?.lotTracking
            if(typeof this.globalSetting?.lotTracking=='boolean' && !this.globalSetting?.lotTracking){
                this.updateLotTracking(this.globalSetting?.lotTracking)
            }
        },
        updateField(field, data){
            this.updatedForm[field] = data
        },
        updatedLotForm(data){
            this.updatedLotInfo = data
        },
        updateLotTracking(val){
            this.lotTracking = val
        },
        changeThcCbdType(val){
            this.productCbdThcType = val
        },
        toggleVariant(val){
            this.disabledVariant = val
        },
        toggle(type, variant){
            if((this.type=='newVariant' && type=='newVariant') || (this.type==type && variant.id ==this.editVariant.id)){
                this.editVariant = {}
                this.type = 'defaultVariant'
                this.vm_currentTab({})
            }else{
                this.editVariant = variant
                this.type = type
                this.vm_currentTab(variant)
            }
        },
        updateMissing(){
            if(this.mergeProduct?.id){
                this.lotTracking = this.mergeProduct.lotTracking?this.mergeProduct.lotTracking:false
                this.updatedForm.name=this.mergeProduct.name
                this.updatedForm.brandId=this.mergeProduct.brandId
                this.updatedForm.categoryId=this.mergeProduct.categoryId
                // !this.updatedForm.featuredCategoryIds?this.updatedForm.featuredCategoryIds=this.mergeProduct.featuredCategoryIds:''
                this.updatedForm.strain=this.mergeProduct.strain
                this.updatedForm.licensedProducer=this.mergeProduct.licensedProducer
                // this.updatedForm.tax?.length===0?this.updatedForm.tax=this.mergeProduct.tax:[]
                this.updatedForm.complianceType=StringHelper.capitalize(this.mergeProduct.complianceType)
                this.updatedForm.concentration_unit=this.mergeProduct.concentration_unit

                this.updatedForm.thc_cbd_value_type=this.mergeProduct.thc_cbd_value_type


                this.updatedForm.description=this.mergeProduct.description
                this.updatedForm.longDescription=this.mergeProduct.longDescription
            }
        },
        ...mapMutations({
            vm_currentTab: 'product/currentTab',
            vm_modified: 'modifiedForm/mutateStatus'
        }),
        ...mapActions({
            va_help: 'help/setHelp'
        })
    }
})
</script>
